import { getPaymentInstruments } from "library/api/payments";
import { useQuery } from "react-query";

export const usePaymentInstruments = () =>
  useQuery("payment_instruments", getPaymentInstruments);
